import { useForm } from "@core/features/form";
import {
  useSignup,
  useGoogleSignup,
  useSignupTracking,
} from "@core/features/auth";
import { SignupForm } from "./SignupForm";
import { Invitation, ClaimedVia } from "@core/features/invitation";

type Props = {
  className?: string;
  invitation: Invitation;
  claimedVia?: ClaimedVia | null;
  onError?: () => void;
  onSuccess?: (data: any) => void;
  isWithAdditionalContent?: boolean;
};

export function SignupFormContainer({
  className,
  invitation,
  claimedVia,
  onError,
  onSuccess,
  isWithAdditionalContent = true,
}: Props) {
  const { signupMutation, schema, defaultValues } = useSignup({
    invitation,
    claimedVia,
    onSuccess,
    onError,
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: signupMutation.mutateAsync,
    defaultValues,
  });

  const googleSignupMutation = useGoogleSignup({
    form,
    invitation,
    claimedVia,
    onSuccess,
    onError,
  });

  // Track signup intent and signup started events
  useSignupTracking({ invitation, watch: form.watch });

  return (
    <SignupForm
      form={form}
      className={className}
      isWithAdditionalContent={isWithAdditionalContent}
      onSignup={handleSubmit}
      onSignupWithGoogle={googleSignupMutation.mutateAsync}
    />
  );
}

export default SignupFormContainer;
